export const bannersPaths = [
  "./assets/banners/Banner-Saude.webp"
]